<script lang="ts">
	import type { ICourseTypeFields } from "$lib/utils/contentful/types";
	import { FeatureBoxCard } from "../Card";
	import FeatureBoxes from "./FeatureBoxes.svelte";

  export let courseType: ICourseTypeFields | null;
</script>

{#if courseType}
  <FeatureBoxes>
    {#if courseType.slug === 'corsi-executive'}
      <FeatureBoxCard>
        <span slot="kpi">30</span>
        <span slot="text">
          anni di esperienza
        </span>
      </FeatureBoxCard>
      <FeatureBoxCard color="dark">
        <span slot="kpi">15</span>
        <span slot="title">Aree tematiche</span>
        <span slot="text">
          per scegliere tra specializzazioni di funzione di settore
        </span>
      </FeatureBoxCard>
      <FeatureBoxCard>
        <span slot="kpi">1200</span>
        <span slot="title">Docenti di estrazione aziendale</span>
        <span slot="text">
          per una formazione business oriented
        </span>
      </FeatureBoxCard>
    {/if}

    {#if courseType.slug === 'corsi-laurea'}
      <FeatureBoxCard>
        <span slot="kpi">3 anni</span>
        <span slot="text">
          Un percorso accademico online in collaborazione con l'Università degli Studi G. Marconi, con l'approccio e l'esperienza di 24ORE Business School
        </span>
      </FeatureBoxCard>
      <FeatureBoxCard color="dark">
        <span slot="kpi">180 CFU</span>
        <span slot="text">
          I CFU sono i Crediti Formativi Universitari e sono gli indicatori con cui, nelle università italiane, viene misurato il carico di lavoro richiesto allo studente per frequentare le lezioni e preparare gli esami
        </span>
      </FeatureBoxCard>
      <FeatureBoxCard>
        <span slot="kpi">50</span>
        <span slot="text">
          attività formative integrative: seminari, lavoratori, company visit, lezioni in live streaming
        </span>
      </FeatureBoxCard>
    {/if}

    {#if courseType.slug === 'corsi-online'}
      <FeatureBoxCard>
        <span slot="kpi">30</span>
        <span slot="text">
          anni di esperienza nella didattica online
        </span>
      </FeatureBoxCard>
      <FeatureBoxCard color="dark">
        <span slot="text">
          Formati online, ovunque tu sia, anche su App 24ORE Business School
        </span>
      </FeatureBoxCard>
      <FeatureBoxCard>
        <span slot="kpi">180+</span>
        <span slot="text">
          corsi con gli specialisti del settore per accrescere e aggiornare le tue competenze
        </span>
      </FeatureBoxCard>
    {/if}

    {#if courseType.slug === 'executive-master'}
      <FeatureBoxCard>
        <span slot="kpi">30</span>
        <span slot="text">
          anni di esperienza
        </span>
      </FeatureBoxCard>
      <FeatureBoxCard color="dark">
        <span slot="kpi">15</span>
        <span slot="title">Aree tematiche</span>
        <span slot="text">
          per scegliere tra specializzazioni di funzione di settore
        </span>
      </FeatureBoxCard>
      <FeatureBoxCard>
        <span slot="kpi">1400</span>
        <span slot="title">Docenti di estrazione aziendale</span>
        <span slot="text">
          per una formazione business oriented
        </span>
      </FeatureBoxCard>
    {/if}

    {#if courseType.slug === 'executive-mba'}
      <FeatureBoxCard>
        <span slot="title">3 anni</span>
        <span slot="text">
          Il Corso di Laurea è articolato in tre anni. È possibile iscriversi al primo o al secondo anno. Le iscrizioni al terzo anno saranno aperte a partire dal 1° luglio 2024.
        </span>
      </FeatureBoxCard>
      <FeatureBoxCard color="dark">
        <span slot="title">180 CFU</span>
        <span slot="text">
          I CFU sono i Crediti Formativi Universitari e sono gli indicatori con cui, nelle università italiane, viene misurato il carico di lavoro richiesto allo studente per frequentare le lezioni e preparare gli esami.
        </span>
      </FeatureBoxCard>
      <FeatureBoxCard>
        <span slot="title">Laurea Triennale</span>
        <span slot="text">
          La durata normale del Corso di Studi è di tre anni accademici. Per conseguire il titolo lo studente deve aver maturato 180 Crediti Formativi Universitari.
        </span>
      </FeatureBoxCard>
    {/if}

    {#if courseType.slug === 'master-post-laurea-con-stage'}
      <FeatureBoxCard>
        <span slot="kpi">95%</span>
        <span slot="text">
          di conferme post stage
        </span>
      </FeatureBoxCard>
      <FeatureBoxCard color="dark">
        <span slot="kpi">1300</span>
        <span slot="text">
          Aziende partner per potenziare le opportunità di lavoro e di crescita professionale
        </span>
      </FeatureBoxCard>
      <FeatureBoxCard>
        <span slot="kpi">50</span>
        <span slot="text">
          borse di studio disponibili
        </span>
      </FeatureBoxCard>
    {/if}

    {#if courseType.slug === 'masterclass'}
      <FeatureBoxCard>
        <span slot="kpi">30</span>
        <span slot="text">
          anni di esperienza nella formazione aziendale
        </span>
      </FeatureBoxCard>
      <FeatureBoxCard color="dark">
        <span slot="text">
          Formazione Smart, Flessibile e Business Oriented con l'obiettivo di generare immediato valore per la propria azienda
        </span>
      </FeatureBoxCard>
      <FeatureBoxCard>
        <span slot="kpi">1300+</span>
        <span slot="text">
          aziende per apprendere nuove conoscenze, per condividere la propria esperienza e per una contaminazione continua, utile ad affrontare nuove sfide in un mercato fortemente dinamico
        </span>
      </FeatureBoxCard>
    {/if}

    {#if courseType.slug === 'mba-full-time'}
      <FeatureBoxCard>
        <span slot="text">
          Diploma di Master in Business & Administration
        </span>
      </FeatureBoxCard>
      <FeatureBoxCard color="dark">
        <span slot="text">
          Network d'eccellenza, le aziende Partner garantiscono docenze aderenti alla quotidianità professionale, Company Visit, Project Work e opportunità di lavoro con un career service dedicato
        </span>
      </FeatureBoxCard>
      <FeatureBoxCard>
        <span slot="text">
          Un percorso unico e immersivo per acquisire competenze trasversali, multidisciplinari e una visione a 360°
        </span>
      </FeatureBoxCard>
    {/if}

    {#if courseType.slug === 'mba-part-time'}
      <FeatureBoxCard>
        <span slot="text">
          Diploma di Master in Business & Administration
        </span>
      </FeatureBoxCard>
      <FeatureBoxCard color="dark">
        <span slot="text">
          Network d'eccellenza che garantisce docenze aderenti alla quotidianità professionale, Company Visit, Project Work e opportunità di lavoro con un career service dedicato
        </span>
      </FeatureBoxCard>
      <FeatureBoxCard>
        <span slot="text">
          Didattica manageriale, flessibile, formula week end e sessioni serali, corsi in auto formazione con specializzazioni Elective
        </span>
      </FeatureBoxCard>
    {/if}

    {#if courseType.slug === 'professional-master'}
      <FeatureBoxCard>
        <span slot="kpi">30</span>
        <span slot="text">
          anni di esperienza
        </span>
      </FeatureBoxCard>
      <FeatureBoxCard color="dark">
        <span slot="kpi">15</span>
        <span slot="title">Aree tematiche</span>
        <span slot="text">
          per scegliere tra specializzazioni di funzione di settore
        </span>
      </FeatureBoxCard>
      <FeatureBoxCard>
        <span slot="kpi">1400</span>
        <span slot="title">Docenti di estrazione aziendale</span>
        <span slot="text">
          per una formazione business oriented
        </span>
      </FeatureBoxCard>
    {/if}

    {#if courseType.slug === 'study-tour'}
      <FeatureBoxCard>
        <span slot="title">3 anni</span>
        <span slot="text">
          Il Corso di Laurea è articolato in tre anni. È possibile iscriversi al primo o al secondo anno. Le iscrizioni al terzo anno saranno aperte a partire dal 1° luglio 2024.
        </span>
      </FeatureBoxCard>
      <FeatureBoxCard color="dark">
        <span slot="title">180 CFU</span>
        <span slot="text">
          I CFU sono i Crediti Formativi Universitari e sono gli indicatori con cui, nelle università italiane, viene misurato il carico di lavoro richiesto allo studente per frequentare le lezioni e preparare gli esami.
        </span>
      </FeatureBoxCard>
      <FeatureBoxCard>
        <span slot="title">Laurea Triennale</span>
        <span slot="text">
          La durata normale del Corso di Studi è di tre anni accademici. Per conseguire il titolo lo studente deve aver maturato 180 Crediti Formativi Universitari.
        </span>
      </FeatureBoxCard>
    {/if}

  </FeatureBoxes>
{/if}
